import ModalMainWrapper from './ModalMainWrapper'
import { ModalStore } from '../../state/ModalStore'

function CalendarTransitionModal({ firstName, onContinue, onChangeAnswers }) {
    const skimModal = ModalStore((state) => state.skim)

    const eyebrow = firstName ? `Great news, ${firstName}!` : 'Great news!'

    const handleContinue = () => {
        skimModal()
        onContinue?.()
    }

    const handleChangeAnswers = () => {
        skimModal()
        onChangeAnswers?.()
    }

    return (
        <ModalMainWrapper>
            <div className="inline-block w-[min(94vw,720px)] max-h-[96vh] overflow-y-auto rounded-[24px] bg-[#FFF6EE] align-middle shadow-[0_18px_40px_rgba(0,0,0,0.22),0_2px_10px_rgba(0,0,0,0.08)] transition-all transform">
                <div className="relative overflow-hidden bg-[#fffaf4] px-3 py-3 sm:px-4 sm:py-4">
                    <div className="absolute right-0 top-0 h-[140px] w-[140px] rounded-full bg-[radial-gradient(circle,rgba(250,179,49,0.12)_0%,transparent_72%)]" />
                    <div className="relative overflow-hidden rounded-[24px] border border-white/40 bg-[#fffaf4] px-4 py-5 text-center sm:px-7 sm:py-7">
                        <span className="absolute left-[7%] top-[16%] h-1 w-2.5 rotate-[24deg] rounded-full bg-[#ed5c2f] opacity-85" />
                        <span className="absolute left-[23%] top-[10%] h-1.5 w-1.5 rounded-full bg-[#fab331] opacity-85" />
                        <span className="absolute right-[24%] top-[11%] h-1.5 w-1.5 rounded-full bg-[#ed5c2f] opacity-85" />
                        <span className="absolute right-[8%] top-[19%] h-1 w-2.5 rotate-[24deg] rounded-full bg-[#f28230] opacity-85" />
                        <span className="absolute left-[9%] top-[60%] h-1 w-3.5 rotate-[24deg] rounded-full bg-[#f28230] opacity-85" />
                        <span className="absolute right-[13%] top-[57%] h-1 w-3.5 rotate-[48deg] rounded-full bg-[#fab331] opacity-85" />
                        <span className="absolute right-[7%] top-[66%] h-1 w-2.5 rotate-[24deg] rounded-full bg-[#ed5c2f] opacity-85" />

                        <div className="relative mx-auto mb-2 flex justify-center">
                            <div className="grid h-[96px] w-[96px] rotate-[-5deg] place-items-center rounded-full border-4 border-[#ed5c2f] bg-white/35 text-[#ed5c2f] sm:h-[108px] sm:w-[108px]">
                                <div className="absolute inset-2 rounded-full border-[1.7px] border-[#ed5c2f]" />
                                <div className="absolute inset-[14px] rounded-full border border-[#ed5c2f]" />
                                <div className="relative z-[1] leading-[0.95]">
                                    <span className="block text-[21px] font-extrabold tracking-[0.8px] sm:text-[24px]">
                                        OLM
                                    </span>
                                    <span className="mt-1 block text-[9px] font-extrabold tracking-[1.1px] sm:text-[10px]">
                                        STAMP OF
                                    </span>
                                    <span className="block text-[9px] font-extrabold tracking-[1.1px] sm:text-[10px]">
                                        APPROVAL
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="mt-3 text-[12px] font-extrabold uppercase tracking-[1.8px] text-[#ed5c2f] sm:text-[13px]">
                            {eyebrow}
                        </div>

                        <h2 className="mt-3 text-[28px] font-extrabold leading-[0.98] tracking-[-1.8px] text-[#27313f] sm:text-[42px]">
                            You&apos;re in the{' '}
                            <span className="text-[#ed5c2f]">right place!</span>
                        </h2>

                        <h3 className="mt-2 text-[18px] font-extrabold leading-[1.15] tracking-[-0.8px] text-[#27313f] sm:text-[24px]">
                            Let&apos;s build a game plan to crush your goals.
                        </h3>

                        <p className="mx-auto mt-3 max-w-2xl text-[13px] leading-[1.45] text-[#8d8d8d] sm:text-[15px]">
                            We&apos;ll discuss where you want to go and map out
                            how direct mail can help you get there.
                        </p>

                        <button
                            type="button"
                            onClick={handleContinue}
                            className="mx-auto mt-6 block w-full max-w-3xl rounded-full bg-[linear-gradient(90deg,#ed5c2f,#ef8245_60%,#f2ad5d)] px-6 py-3 text-white shadow-[0_12px_28px_rgba(237,92,47,0.24)] transition hover:-translate-y-0.5 hover:shadow-[0_16px_34px_rgba(237,92,47,0.30)] sm:text-[17px]">
                            <span className="text-[16px] font-extrabold">
                                Build my game plan →
                            </span>
                        </button>

                        <button
                            type="button"
                            onClick={handleChangeAnswers}
                            className="mx-auto mt-3 block px-3 py-1.5 text-[12px] text-[#6f7379] transition hover:text-[#ed5c2f] sm:text-[13px]">
                            ← Change my answers
                        </button>
                    </div>
                </div>
            </div>
        </ModalMainWrapper>
    )
}

export default CalendarTransitionModal
